import { clsx, type ClassValue } from 'clsx'
import dayjs from 'dayjs'
import { twMerge } from 'tailwind-merge'
import z from 'zod/v4'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const mergePaths = (baseUrl: string, path: string) => {
  const baseUrlWithoutSlash = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl

  const pathWithSlash = path.startsWith('/') ? path : `/${path}`

  return `${baseUrlWithoutSlash}${pathWithSlash}`
}

export function getValidDate(date: string | Date | undefined | null): Date | undefined {
  if (!date) {
    return undefined
  }

  const nextDate = dayjs(date)

  if (!nextDate.isValid()) {
    return undefined
  }

  return nextDate.toDate()
}

export function isUrl(url: unknown): url is string {
  return z.url().safeParse(url).success
}

export function isWebUrl(url: unknown): url is string {
  if (typeof url !== 'string') {
    return false
  }

  try {
    const urlObj = new URL(url)
    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:'
  } catch {
    return false
  }
}

export function isFileUrl(url: unknown): url is string {
  return (
    typeof url === 'string' &&
    z
      .url({
        protocol: /^data|blob|file$/,
      })
      .safeParse(url).success
  )
}

export function formatTimeAgo(dateString: string): string {
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
  const diffWeeks = Math.floor(diffDays / 7)
  const diffMonths = Math.floor(diffDays / 30)

  if (diffMonths >= 1) {
    // eslint-disable-next-line i18next/no-literal-string
    return `${diffMonths} kk sitten`
  }

  if (diffWeeks >= 1) {
    // eslint-disable-next-line i18next/no-literal-string
    return `${diffWeeks} vk sitten`
  }

  if (diffDays >= 1) {
    // eslint-disable-next-line i18next/no-literal-string
    return `${diffDays} pv sitten`
  }

  // eslint-disable-next-line i18next/no-literal-string
  return 'alle pv'
}
